<div>
  <p>{{ 'revenue.posted-batches.posted-batches-for' | translate | titlecase }}</p>

  <div class="mct-flex mct-row mct-gap-16"  >
    <p-radioButton value="detailed-transactions" [(ngModel)]="batchesShown" inputId="detailedTransactions"> </p-radioButton>
    <label for="detailedTransactions">
      {{ 'revenue.posted-batches.detailed-transactions-label' | translate | ucfirst }}
    </label>
    <p-radioButton value="journal-entries" [(ngModel)]="batchesShown" inputId="journalEntries"> </p-radioButton>
    <label for="journalEntries">
      {{ 'revenue.posted-batches.journal-entries-label' | translate | ucfirst }}
    </label>
  </div>
</div>

<p class="mt-28">{{ 'revenue.posted-batches.select-transactions-from' | translate | titlecase }}</p>

<div   class="mb-27 mct-flex mct-row mct-gap-16">
  <div>
    <p>{{ 'revenue.posted-batches.apply-date' | translate | titlecase }}</p>
    <div class="mct-flex mct-row mct-gap-16"  >
      <wl-date-selector [(ngModel)]="searchDto.ApplyDateStart"></wl-date-selector>
      <span>{{ 'common.to' | translate | uppercase }}</span>
      <wl-date-selector [(ngModel)]="searchDto.ApplyDateEnd"></wl-date-selector>
    </div>
  </div>

  <div>
    <p>{{ 'revenue.posted-batches.posted-date' | translate | titlecase }}</p>
    <div class="mct-flex mct-row mct-gap-16"  >
      <wl-date-selector [(ngModel)]="searchDto.DatePostedStart"></wl-date-selector>
      <span>{{ 'common.to' | translate | uppercase }}</span>
      <wl-date-selector [(ngModel)]="searchDto.DatePostedEnd"></wl-date-selector>
    </div>
  </div>
</div>
<div class="mct-flex mct-row mct-gap-27"  >
  <div  class="w-12 mct-flex mct-col">
    <label>{{ 'revenue.posted-batches.choose-accounting-package' | translate | titlecase }}</label>
    <p-select
      name="accountingPackage"
      placeholder="{{ 'common.select' | translate | titlecase }}"
      [options]="accountingPackages"
      [(ngModel)]="searchDto.AccountingPackageID"
      showClear
      [style]="{ width: '100%' }"
    ></p-select>
  </div>
  <div  class="w-12 mct-flex mct-col" *ngIf="batchesShown != 'journal-entries'">
    <label>{{ 'revenue.posted-batches.choose-transaction-type' | translate | titlecase }}</label>
    <p-select
      name="transactionType"
      placeholder="{{ 'common.select' | translate | titlecase }}"
      [options]="transactionTypes"
      [(ngModel)]="searchDto.TransactionType"
      showClear
      [style]="{ width: '100%' }"
    ></p-select>
  </div>

  <div>
    <label>{{ 'revenue.posted-batches.batch-number' | translate | titlecase }}</label>
    <input pInputText type="text" name="BatchPosting" [(ngModel)]="searchDto.BatchPosting" />
  </div>
  <div>
    <label>{{ 'revenue.posted-batches.account-number' | translate | titlecase }}</label>
    <input pInputText type="text" name="accountNumber" [(ngModel)]="searchDto.Account" />
  </div>
</div>

<div    class="mt-28 mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-16">
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="clearSearch()">
    {{ 'common.clear' | translate | uppercase }}
  </button>
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="runSearch()">
    {{ 'revenue.posted-batches.run-this-search' | translate | uppercase }}
  </button>
</div>

<hr />

<wl-detailed-transactions-grid
  #transactionsGrid
  *ngIf="firstSearchRun == true && batchesShown == 'detailed-transactions'"
  [searchDto]="searchDto"
></wl-detailed-transactions-grid>
<wl-journal-entries-grid
  #journalsGrid
  *ngIf="firstSearchRun == true && batchesShown == 'journal-entries'"
  [searchDto]="searchDto"
></wl-journal-entries-grid>
